import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { ADGMModal, ADGMBreadcrumbs, ADGMImage } from 'aurora-components';

import appContent from 'aurora-api/dummy/appContent';

import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

import styles from './styles';

function ApprovalLayout(props) {
  const title = appContent.name + ' - Landing Screen';
  const description = appContent.desc;

  const [isModalOpenApplicationReject, setModalOpenApplicationReject] = useState(false);
  const toggleModalApplicationReject = () => {
    setModalOpenApplicationReject(!isModalOpenApplicationReject);
  };

  const { classes, children, breadcrumbs, id, handleSubmitCancelApplication, applicant, applicationType } = props;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name='description' content={description} />
        <meta property='og:title' content={title} />
        <meta property='og:description' content={description} />
        <meta property='twitter:title' content={title} />
        <meta property='twitter:description' content={description} />
      </Helmet>

      <div className={classes.main}>
        <Container className={classes.container}>
          <Hidden mdDown>
            <div className={classes.breadcrumbsHolder}>
              <ADGMBreadcrumbs paths={breadcrumbs} />
              {applicationType !== 'PMA_REGISTRATION' && (
                <Typography className={classes.serviceid}>
                  <FormattedMessage {...messages.Application_ID} />:{' '}
                  <Typography className={classes.applicationNumber} component='strong'>
                    {id}
                  </Typography>
                </Typography>
              )}
            </div>
          </Hidden>
          <Hidden mdUp>
            <div className={classes.mobileTitlehead}>
              <div>
                <Link href='/app/applications'>
                  <ADGMImage name='croseblackonmobile.svg' alt='croseimg' />{' '}
                  <FormattedMessage {...messages.review_contract} />
                </Link>
              </div>

              {applicant === 'initiator' && (
                <Hidden mdUp>
                  <div className={classes.trashIcon}>
                    {' '}
                    <ADGMImage name='trash_red.svg' alt='trash' onClick={toggleModalApplicationReject} aria-hidden />
                  </div>
                </Hidden>
              )}
            </div>
          </Hidden>
          {children}
        </Container>
      </div>
      <ADGMModal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenApplicationReject}
        toggleModal={toggleModalApplicationReject}
        onClose={toggleModalApplicationReject}
      >
        <div className={classes.innerModalAccept}>
          <ADGMImage
            name='cross.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            aria-hidden='true'
            onClick={toggleModalApplicationReject}
          />
          <Typography variant='h6' component='h1' className={classes.Title}>
            <FormattedMessage {...messages.terminate_application_title} />
          </Typography>
          <Typography variant='h6' component='h2' className={classes.subTitle}>
            <FormattedMessage {...messages.this_will_terminate_the_application} />
          </Typography>
          <div className={classes.modalBtnholder}>
            <Button
              variant='outlined'
              className={classNames(classes.btns, classes.TerminateBtn)}
              size='large'
              onClick={toggleModalApplicationReject}
            >
              <FormattedMessage {...messages.cancel} />
            </Button>
            {handleSubmitCancelApplication && (
              <Button
                variant='contained'
                className={classNames(classes.btns, classes.modalAccptBtn)}
                size='large'
                onClick={handleSubmitCancelApplication}
              >
                <FormattedMessage {...messages.terminate} />
              </Button>
            )}
          </div>
        </div>
      </ADGMModal>
    </>
  );
}

ApprovalLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.array,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  applicant: PropTypes.string.isRequired,
  handleSubmitCancelApplication: PropTypes.func,
  applicationType: PropTypes.string,
};

ApprovalLayout.defaultProps = {
  applicationType: '',
  breadcrumbs: [],
  handleSubmitCancelApplication: null,
};
export default withStyles(styles)(ApprovalLayout);
